'use client';

import { useFormStatus } from 'react-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import classNames from 'classnames';

import { Button } from '@/components/Buttons';
import { useRef, useState } from 'react';

const siteKey = '6LfFCBUpAAAAADSVYZeixjs1GOc8xZXVkJbNtVZ5';

export const SubmitButton = ({ children }: { children: React.ReactNode }) => {
  const { pending } = useFormStatus();
  const [token, setToken] = useState<string | null>();
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  async function handleCaptchaSubmission(token: string | null) {
    setToken(token);
  }

  const disabled = pending || !token;

  return (
    <div className="flex flex-col items-end gap-4">
      <ReCAPTCHA sitekey={siteKey} ref={recaptchaRef} onChange={handleCaptchaSubmission} />
      <input type="hidden" name="recaptcha-token" defaultValue={token ?? ''} />
      <Button
        className={classNames({ 'pointer-events-none touch-none': disabled })}
        type="submit"
        aria-disabled={disabled}
        disabled={disabled}
      >
        {children}
      </Button>
    </div>
  );
};
